import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { provideChildTranslateService } from "@ngx-translate/core";
import { UiModule } from "@partikelart/portal/ui";
import { ButtonModule } from "primeng/button";
import { CardModule } from "primeng/card";
import { StepsModule } from "primeng/steps";
import { TableModule } from "primeng/table";
import { routes } from "./feature-export.routing";
@NgModule({
	imports: [CommonModule, RouterModule.forChild(routes), CardModule, StepsModule, ButtonModule, TableModule, UiModule],
	providers: [provideChildTranslateService()],
})
export class FeatureExportModule {}
